import { FiltersFormModal } from '@/app/_components/widgets/listing/listingFilters/filtersModal';
import { useDisableBodyScroll } from '@/app/_hooks/useDisableBodyScroll';
import { FilterStates, useListingFilters } from '@/app/_hooks/useListingFilters';
import { ELTagButton } from '@davincihealthcare/elty-design-system-react';
import { AdjustmentsHorizontalIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

type FiltersFormType = {
  showMap: () => void;
  filterLight?: boolean;
};

const FiltersForm = ({ showMap }: FiltersFormType) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useDisableBodyScroll(isModalOpen);

  const { filters } = useListingFilters();

  return (
    <div className="h-13 bg-neutral-active px-4 py-2 ">
      <div className="container mx-auto flex w-full flex-row items-center justify-between">
        <ELTagButton
          leadingIcon={<AdjustmentsHorizontalIcon />}
          label="Filtri"
          onClick={() => setIsModalOpen(true)}
          state={
            Object.keys(filters)
              .filter(key => key !== 'order')
              .some(filterKey => !!filters[filterKey as keyof FilterStates]?.length)
              ? 'active'
              : undefined
          }
        />

        <ELTagButton leadingIcon={<MapPinIcon />} label="Mappa" onClick={showMap} />
      </div>

      {isModalOpen && <FiltersFormModal onClose={() => setIsModalOpen(false)} />}
    </div>
  );
};

export default FiltersForm;
